<template>
  <div :class="[(menuOpen ? 'menu-open' : ''), 'main']">
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <BackWrapper />

    <div class="page-content">
      <Logo :style="logo" @click="hideMenu()" />
      <transition name="fade">
        <div class="content">
          <router-view :key="$route.fullPath" />
        </div>
      </transition>
      <SideBar 
        :class="[(sidebarColor ? 'background' :'')]" 
        :style="sidebarColor ? ('background-color: ' + sidebarColor) : ''"
        :active="menuOpen"
        @loggleMenu="loggleMenu()"
       />

      <Menu :active="menuOpen" :menu="menu" @menuclick="menuclick" />
    </div>
  </div>
</template>
<script>
import ApiClient from '../api/index'
import SideBar from './SideBar.vue'
import Menu from './Menu.vue'
import Logo from './Logo.vue'
import BackWrapper from './BackWrapper.vue'
import $ from "jquery";
import completeLoad from '../mixins/completeLoad'

export default {
  components: {
    SideBar,
    Logo,
    Menu,
    BackWrapper
  },

  mixins: [completeLoad],

  computed: {
    sidebarColor () {
      return this.$store.state.sidebarColor
    },

    progress () {
      return this.$store.state.progress
    },

    logo () {
      let style = {}

      if (!this.menuOpen) {
        return style
      }

      if ($(window).width() > 768) {
        style = {
          left: '50%',
          transform: 'translate(-50%, 0%)'
        }
      } else {
        style = {
          left: '8%'
        }
      }

      this.fxLogo()
      return style
    }
  },

  data () {
    return {
      menu: [],
      menuOpen: false
    }
  },

  mounted () {
    var sidebar = $('.sidebar')
    var menu = $('.menu')  

    $(window).on('resize', () => {
        this.fxHeoght()
    });

    menu.scroll(function(e) {
      if (menu.hasClass('scroll')) {
        sidebar.css('top', -1 * menu.scrollTop())
      }
    });

    $(window).resize(function(e) {
      if (menu.hasClass('scroll')) {
        sidebar.css('top', -1 * menu.scrollTop())
      } else {
        sidebar.css('top', 0)
      }
    })
  },

  methods: {
    backSidebar () {
      $('.sidebar').css('top', 0)
      $( ".menu" ).scrollTop(0)
    },

    progressStart () {
      this.$refs.topProgress.start()
    },

    progressStop () {
      this.$refs.topProgress.done()
    },

    loggleMenu () {
      this.menuOpen = !this.menuOpen
    },

    hideMenu() {
      this.menuOpen = false
    },

    menuclick(menu) {
      this.$router.push({ path: menu.link })
      this.hideMenu()
    },

    fxHeoght() {
      $(".content").css('opacity', this.menuOpen ? 0 : 1)
      let body = $("html, body")
      let main = $('.main')

      if (this.menuOpen) {
        main.height(main.height())
        body.addClass('overflow-hidden')
        body.animate({ scrollTop: 0 });
      } else {
        body.removeClass('overflow-hidden')
        main.height($(window).width() > 1024 ? '100vh' : 'auto')
      }
    }
  },

  beforeCreate () {
    ApiClient.menu()
      .then(response => {
        this.menu = response.data
      })
  },

  watch: {
    progress (val) {
      if (val) {
        this.progressStart()
      } else {
        this.progressStop()
      }
    },
    menuOpen (val) {
      this.fxHeoght()
      if (!val) {
        this.backSidebar()
      } else {
        $( ".menu" ).scrollTop(0)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/main';
.overflow-hidden {
  height: 100%;
  position: fixed;
  overflow: hidden;
  width: 100%;
}
.main {
  position: relative;
	height: 100vh;
  display: flex;
  overflow: hidden;
  background-color: #111020;

  &.menu-open {
    min-height: 100vh;
  }
  .page-content {
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .content {
    transition: all .4s ease;
    width: calc(100% - 100px);
  }
}

.content {
  .left {
    padding: 180px 130px 20px 115px;
  }
}
</style>
